import React from 'react';
import { Provider } from 'react-redux';
export function createMockStoreWrapper(store) {
  var Wrapper = function Wrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/React.createElement(Provider, {
      store: store
    }, children);
  };

  return Wrapper;
}